import React, { useMemo } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import {
  getDatePickerRangeLabel,
  getDatePickerRangeOptions,
} from '../../util/utils';

interface Props {
  startDate: moment.Moment;
  endDate: moment.Moment;
  applyRange: (newRange: any) => void;
  searchTerm: string;
  onSearch: (searchTerm: string) => void;
}

const ranges = getDatePickerRangeOptions();

export const UpstartLoanStatusHeader: React.FC<Props> = ({
  startDate,
  endDate,
  applyRange,
  searchTerm,
  onSearch,
}) => {
  const rangeLabel = useMemo(
    () => getDatePickerRangeLabel(ranges, startDate, endDate),
    [startDate, endDate],
  );

  const displayRange = useMemo(
    () =>
      [
        moment(startDate).format('YYYY/MM/DD'),
        moment(endDate).format('YYYY/MM/DD'),
      ].join(' - '),
    [startDate, endDate],
  );

  return (
    <div className="loan-status-dashboard-header">
      <div className="dashboard-filters">
        <div>
          <span className="display-range-label-name">{rangeLabel}</span>
          <span className="display-range-label-date">{displayRange}</span>
          <DateRangePicker
            startDate={startDate}
            endDate={endDate}
            onApply={(e, newRange) => applyRange(newRange)}
            // @ts-ignore
            ranges={ranges}
          >
            <button
              type="button"
              className="btn btn-primary margin-left margin-right"
            >
              <i className="glyphicon glyphicon-calendar" />
            </button>
          </DateRangePicker>
          <span className="display-range-label">{}</span>
        </div>
      </div>
      <div className="loan-status-search-box">
        <input
          type="text"
          className="form-control input"
          name="loanStatusSearch"
          placeholder="Try: Customer Name, Contract #, Vehicle, Status"
          value={searchTerm}
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>
    </div>
  );
};
